import * as THREE from 'three'
import { useEffect, useMemo, useState, useRef } from 'react'
import { useThree } from "@react-three/fiber";
import { Text3D, Text, Center, Float, Gltf } from "@react-three/drei";
import { RigidBody } from '@react-three/rapier'
import { useManosStore } from './Hook'
import gsap from "gsap";

import { useNavigate } from 'react-router-dom';




// Mesh
const titleMesh = new THREE.MeshMatcapMaterial({ color: 'blue', opacity: 0.8 })

export default function object() {

    // UseNavigate pour redirection page

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/services');
    };

    //Animation de la wireframe

    const [enableWireframe, setEnableWireframe] = useState(true)

    //Animation de la wireframe

    const [colorChange, setColor] = useState('#7DA7A3')

    // Gestion de la caméra

    const { camera } = useThree()
    const { setZoomArcade, setShowIframe } = useManosStore()

    const enterScene = () => {

        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    setZoomArcade(true)
                    setShowIframe(false)
                }, 400)
            }
        })
            .to(camera.position, { x: -3, y: -6, z: 0, duration: 6 }, 0)
            .to(camera.rotation, {
                duration: 4,
                x: 0,
                y: 2,
                z: 0,
            }, 0)

            .to(camera.position, { x: -8, y: -0.5, z: 5.0, duration: 4 }, 2)

    }

    const enterScene1 = () => {

        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    setZoomArcade(true)
                    setShowIframe(false)
                }, 400)
            }
        })
            .to(camera.position, { x: -12, y: 4, z: 4, duration: 4 }, 0)
            .to(camera.rotation, {
                duration: 4,
                x: 0,
                y: 3,
                z: 0,
            }, 0)


    }

    const enterScene2 = () => {

        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    setZoomArcade(true)
                    setShowIframe(false)
                }, 400)
            }
        })
            .to(camera.position, { x: -18, y: -1, z: -2, duration: 4 }, 0)
            .to(camera.rotation, {
                duration: 6.3,
                x: 0.0,
                y: 2.35,
                z: 0,
            }, 0)


    }


    const leaveScene = () => {
        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    setZoomArcade(true)
                    setShowIframe(false)
                }, 400)
            }
        })
            .to(camera.position, { x: 0, y: 0, z: 10.2, duration: 5 }, 0)
            .to(camera.rotation, {
                duration: 6.3,
                x: 0,
                y: -0.0,
                z: 0,
            }, 0)



    }
    return <>

        <RigidBody type="kinematicPosition">
            <Center disableZ disableX disableY>
                <Text3D font="./fonts/helvetiker_regular.typeface.json"
                    position={[
                        -0.25,
                        -0.4,
                        9,
                    ]}
                    rotation={[0, 0.0, 0]}
                    material={titleMesh}
                    smooth={0.11}
                    scale={0.15}
                    size={1}
                    height={0.2}
                    curveSegments={5}
                    bevelEnabled
                    bevelThickness={0.0}
                    bevelSize={0.02}
                    bevelOffset={0.0}
                    bevelSegments={5}
                    onClick={handleClick}
                    maxWidth={2}
                    onPointerEnter={() => {
                        setColor('#F5BC3D')
                        document.body.style.cursor = `pointer`
                    }}
                    onPointerLeave={() => {
                        setColor('#7DA7A3')

                        document.body.style.cursor = `initial`
                    }}
                >
                    GLADTOFINDU
                    <meshStandardMaterial castShadow wireframe={false} color={colorChange} opacity={0.2} />
                </Text3D>
            </Center>

        </RigidBody>


        <RigidBody type="kinematicPosition">
            <Center disableZ disableX disableY>
                <Float
                    speed={0.4} // Animation speed, defaults to 1
                    rotationIntensity={0.2} // XYZ rotation intensity, defaults to 1
                    floatIntensity={0.3} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
                    floatingRange={[-0.05, 0.05]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
                >
                    <Text3D font="./fonts/helvetiker_regular.typeface.json"
                        position={[
                            -1.5,
                            0.2,
                            8,
                        ]}
                        rotation={[0, 0.3, 0]}
                        material={titleMesh}
                        smooth={0.11}
                        scale={0.15}
                        size={1}
                        height={0.2}
                        curveSegments={5}
                        bevelEnabled
                        bevelThickness={0.0}
                        bevelSize={0.02}
                        bevelOffset={0.0}
                        bevelSegments={5}
                        onClick={enterScene}
                        maxWidth={2}
                        onPointerEnter={() => {
                            setEnableWireframe(false)
                            document.body.style.cursor = `pointer`
                        }}
                        onPointerLeave={() => {
                            setEnableWireframe(true)
                            document.body.style.cursor = `initial`
                        }}
                    >
                        First Visit?
                        <meshStandardMaterial castShadow wireframe={enableWireframe} color={'#F5BC3D'} />
                    </Text3D>
                </Float>
            </Center>
        </RigidBody>



        <RigidBody type="kinematicPosition">
            <Text3D font="./fonts/helvetiker_regular.typeface.json"
                position={[
                    -10, -0.5, 6.7
                ]}
                rotation={[0, 2, 0]}
                material={titleMesh}
                smooth={0.11}
                scale={0.25}
                size={1}
                height={0.2}
                curveSegments={5}
                bevelEnabled
                bevelThickness={0.0}
                bevelSize={0.02}
                bevelOffset={0.0}
                bevelSegments={5}
                onClick={enterScene1}
                maxWidth={2}
                onPointerEnter={() => {
                    setEnableWireframe(false)
                    document.body.style.cursor = `pointer`
                }}
                onPointerLeave={() => {
                    setEnableWireframe(true)
                    document.body.style.cursor = `initial`
                }}
            >
                Who am I ?
                <meshStandardMaterial castShadow wireframe={enableWireframe} color={'#F5BC3D'} />
            </Text3D>
        </RigidBody>

        <RigidBody type="kinematicPosition">

            <Text3D font="./fonts/helvetiker_regular.typeface.json"
                position={[
                    -12, 5.1, 8
                ]}
                rotation={[0, 3, 0]}
                material={titleMesh}
                smooth={0.11}
                scale={0.25}
                size={1}
                height={0.2}
                curveSegments={5}
                bevelEnabled
                bevelThickness={0.0}
                bevelSize={0.02}
                bevelOffset={0.0}
                bevelSegments={5}
                onClick={enterScene2}
                maxWidth={2}
                onPointerEnter={() => {
                    setEnableWireframe(false)
                    document.body.style.cursor = `pointer`
                }}
                onPointerLeave={() => {
                    setEnableWireframe(true)
                    document.body.style.cursor = `initial`
                }}
            >
                How does it work?
                <meshStandardMaterial castShadow wireframe={enableWireframe} color={'#F5BC3D'} />
            </Text3D>


        </RigidBody>


        <RigidBody type="kinematicPosition">
            <Center disableZ disableX disableY>
                <Text3D font="./fonts/helvetiker_regular.typeface.json"
                    position={[
                        -20, -0.5, 0
                    ]}
                    rotation={[0, 2.5, 0]}
                    material={titleMesh}
                    smooth={0.11}
                    scale={0.25}
                    size={1}
                    height={0.2}
                    curveSegments={5}
                    bevelEnabled
                    bevelThickness={0.0}
                    bevelSize={0.02}
                    bevelOffset={0.0}
                    bevelSegments={5}
                    onClick={leaveScene}
                    maxWidth={2}
                    onPointerEnter={() => {
                        setEnableWireframe(false)
                        document.body.style.cursor = `pointer`
                    }}
                    onPointerLeave={() => {
                        setEnableWireframe(true)
                        document.body.style.cursor = `initial`
                    }}
                >
                    Recommendation
                    <meshStandardMaterial castShadow wireframe={enableWireframe} color={'#F5BC3D'} />
                </Text3D>
            </Center>

        </RigidBody>
        <Center disableZ disableX disableY>
            <Text
                color={'#454545'}
                position={[
                    0.7,
                    0.3,
                    9,
                ]}
                rotation={[0.0, 0, 0]}
                scale={0.04}>
                "Discover the Art of Next-Gen Data Visualization" {'\n'}
                "Embark on a Journey of Unprecedented {'\n'}
                user Experience with an interactive Map"{'\n'}
            </Text>
        </Center>

        <Text3D font="./fonts/helvetiker_regular.typeface.json"
            color={'#F5BC3D'}
            position={[
                -10, -1, 7
            ]}
            rotation={[0.0, 2, 0]}
            scale={0.10}>
            {'< My name is Anthony PHO'}{'\n'}
            {' I am a Fullstack developer />'}{'\n'}

            <meshStandardMaterial color={'#F5BC3D'} />
        </Text3D>

        <Text3D font="./fonts/helvetiker_regular.typeface.json"
            color={'#F5BC3D'}
            position={[
                -11, 4.8, 8
            ]}
            rotation={[0.0, 3, 0]}
            scale={0.10}>
            {'< I develop an innovative 3D data visualization application that'}{'\n'}
            {' allows users to navigate on a map and view key data about the '}{'\n'}
            {' streets of the 13th district of Paris, such as the revenue and net '}{'\n'}
            {' profit of selected businesses/>'}{'\n'}
            <meshStandardMaterial color={'#F5BC3D'} />
        </Text3D>

        <Center disableX disableY disableZ>
            <Text3D font="./fonts/helvetiker_regular.typeface.json"
                color={'#F5BC3D'}
                position={[
                    -20, -1, -0.0
                ]}
                rotation={[-0.0, 2.45, 0]}
                scale={0.06}>
                {'< We recommend registering on our platform to enjoy the latest updates '}{'\n'}
                {' and advanced features. It is also recommended to have a computer with'}{'\n'}
                {' a minimum configuration of 16GB of RAM and an M1 processor to ensure '}{'\n'}
                {' the best user experience/>'}{'\n'}
                <meshStandardMaterial color={'#F5BC3D'} />
            </Text3D>
        </Center>

        <Gltf src="./3dmodels/city_last_version_green.glb"
            receiveShadow
            castShadow
            rotation={[0, 2, 0]}
            scale={0.25}
            position={[
                -4,
                5,
                -16,
            ]} />

    </>

}